import React from "react";
import PreLogin from "../../../components/Layouts/PreLogin";
import useDarkmode from "../../../utils/utilityHooks/useDarkmode";

import DarkThemeToggler from "../../DarkThemeToggler";
import NoDataContainer from "./NoDataContainer";
import ProfileContainer from "./ProfileContainer";
import { useShareProfile } from "./useShareProfile";

const ShareUserProfile = () => {
  const { theme, themeToggler } = useDarkmode();

  const { data, urlExpired } = useShareProfile();

  return (
    <div>
      <PreLogin hasFooter={true}>
        {urlExpired && Object?.keys(data)?.length == 0 ? (
          <NoDataContainer />
        ) : (
          <ProfileContainer data={data} />
        )}
      </PreLogin>
      <DarkThemeToggler theme={theme} toggleTheme={themeToggler} />
    </div>
  );
};

export default ShareUserProfile;
